import React from 'react';

/**
 * PiPauseBigSolid icon from the solid style in media category.
 */
interface PiPauseBigSolidProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiPauseBigSolid({
	size = 24,
	color,
	className,
	ariaLabel = 'pause-big icon',
	...props
}: PiPauseBigSolidProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				d="M5 6.8c0-1.158 0-1.832.299-2.419A2.75 2.75 0 0 1 6.5 3.18C7.087 2.88 7.761 3 8.8 3h.4c1.039 0 1.713-.12 2.3.18a2.75 2.75 0 0 1 1.201 1.201c.299.587.299 1.261.299 2.419v10.4c0 1.158 0 1.832-.299 2.419a2.75 2.75 0 0 1-1.201 1.201c-.587.3-1.261.18-2.3.18h-.4c-1.039 0-1.713.12-2.3-.18a2.75 2.75 0 0 1-1.201-1.201C5 19.032 5 18.358 5 17.2zm8 0c0-1.158 0-1.832.299-2.419A2.75 2.75 0 0 1 14.5 3.18C15.087 2.88 15.761 3 16.8 3h.4c1.039 0 1.713-.12 2.3.18a2.75 2.75 0 0 1 1.201 1.201c.299.587.299 1.261.299 2.419v10.4c0 1.158 0 1.832-.299 2.419a2.75 2.75 0 0 1-1.201 1.201c-.587.3-1.261.18-2.3.18h-.4c-1.039 0-1.713.12-2.3-.18a2.75 2.75 0 0 1-1.201-1.201C13 19.032 13 18.358 13 17.2z"
				fill="currentColor"
			/>
		</svg>
	);
}
